/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ApiKeyModel {
        public keys: Wars.Domain.Model.ApiKey[];
        public newKeyName:string;

        constructor(private apiKeyService: warsApp.services.ApiKeyService) {
            this.apiKeyService.getKeys().then(keys => {
                this.keys = keys;
            });
        }

        public add() {
            this.apiKeyService.addKey(this.newKeyName).then(r => {
                this.keys.push(r);
            });
        }

        public updateKey(key: Wars.Domain.Model.ApiKey) {
            this.apiKeyService.updateKey(key);
        }
    }
}